// @ts-nocheck

import * as React from 'react';
import {RadioGroup} from '@spaced-out/ui-design-system/lib/components/RadioButton';

import {RadioPair} from './common';


type RadioButtonsProps<T> = {
  name: string;
  selectedValue: T;
  onChange: (value: T) => void;
  options: {
    value: T;
    label: string;
  }[];
  className?: string;
  labelClassName?: string;
  bodyClassName?: string;
};

const RadioButtons = <T extends unknown>({
  name,
  selectedValue,
  onChange,
  options,
  className,
  labelClassName,
  bodyClassName,
}: RadioButtonsProps<T>) => (
  <RadioGroup
    className={className}
    name={name}
    value={selectedValue}
    onChange={onChange}
  >
    {options.map((choice) => {
      return RadioPair({
        className: {labelClassName},
        key: String(choice.value),
        label: choice.label,
        value: choice.value,
        isHorizontal: true,
      });
    })}
  </RadioGroup>
);

export default RadioButtons;
